import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { useAuth } from './AuthContext';

const LoginPage = () => {
  const { t } = useLanguage();
  const { loginPatient, loginProfessional, signupPatient } = useAuth();

  return (
    <div style={{ padding: '20px', maxWidth: 720, margin: '0 auto' }}>
      <h2>{t('login.title')}</h2>
      <p style={{ color: '#5b6b7d' }}>
        Choose the sign-in flow that matches your current role. Existing booking and dashboard sessions will be restored after login.
      </p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
        <button
          onClick={() => loginPatient()}
          style={{
            backgroundColor: '#1e88e5',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '999px'
          }}
        >
          {t('login.button')}
        </button>
        <button
          onClick={() => signupPatient()}
          style={{
            backgroundColor: '#eef5ff',
            color: '#1e3a5f',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '999px'
          }}
        >
          Create patient account
        </button>
        <button
          onClick={() => loginProfessional()}
          style={{
            backgroundColor: '#123a5d',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '999px'
          }}
        >
          Provider sign-in
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
